import {$createParagraphNode, $createTextNode, $getRoot,} from "lexical"
import {ContentRTF, RTFVersion} from "../@type"
import lexical_convertFromMarkdown from "./convert-from-markdown"
import {migrateLegacyTables} from "./migrate-legacy-table"

// const debug = "lexicalGetInitialEditorState"
const debug = false

export function lexicalGetInitialEditorState(
    messageText?    : string,
    messageRTF?     : ContentRTF
): any {

    let res
    if (messageRTF) {

        // New. Used in AI chat messages
        if (messageRTF.v === RTFVersion.MARKDOWN && !!messageRTF.markdown) {

            res = function() {
                lexical_convertFromMarkdown(messageRTF.markdown)
            }

        } else if (!messageRTF.content && messageRTF.v === RTFVersion.CLICKUP_IMPORT && !!messageRTF.importOriginal) {

            res = function() {
                lexical_convertFromMarkdown(messageRTF.importOriginal)
            }

        } else {

            // legacy 'tablesheet' nodes -> @lexical/table tree
            res = JSON.stringify(migrateLegacyTables(messageRTF.content))

        }
    } else if (messageText) { // add text if no messageRTF and messageText is passed
        res = function (){
            const root = $getRoot();
            if (root.getFirstChild() === null) {
                const paragraph = $createParagraphNode();
                paragraph.append(
                    $createTextNode(messageText)
                )
                root.append(paragraph)
            }
        }
    }

    return res
}
